import { schemaTypes } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import { JSONToCSVConvertor } from "../../../helpers/helperFunctions";
import actions from "../../../store/actions";

const PAGE_LIMIT = 100;

export const processData = (resp, callback) => {
  const data = (resp || []).map((item) => {
    const tenure = item.remainingtenure || {};

    return {
      vehicleno: item.vehicleno,
      deviceno: item.deviceno,
      activationstart: item.activationstart != null ? item.activationstart : "-",
      activationend: item.activationend != null ? item.activationend : "-",
      remainingtenure: `${tenure.months || 0} months ${tenure.days || 0} days`,
      subscriptionstatus: item.subscriptionstatus,
      isactive: item.isactive ? "Active" : "Inactive",
    };
  });

  callback(data);
};

export const getHistory = (schema, store) => {
  schema.showPage = true;
  schema.finalData = null;

  const vehicleMap = store.vehicleMap || window.vehicleMap || {};
  const vehicleCount = Object.keys(vehicleMap).filter(
    (key) => key.indexOf("user") === -1
  ).length;
  schema.count = Math.ceil(vehicleCount / PAGE_LIMIT);

  if (window.setReportWindowTabBusy) {
    window.setReportWindowTabBusy(schema, true);
  }
  if (schema.content[0].ref) {
    schema.content[0].ref.setBusy(true);
  }

  const handleSuccess = (resp) => {
    if (window.setReportWindowTabBusy) {
      window.setReportWindowTabBusy(schema, false);
    }

    processData(resp, (data) => {
      schema.finalData = data;
      store.dispatch({
        type: actions.SELECTED_VEHICLE_ID,
        data: {
          reportName: schema.key,
          subscriptionFirstData: data,
          subscriptionPageno: schema.count,
          showPage: schema.showPage,
        },
      });

      if (schema.content[0].ref) {
        schema.content[0].ref.setData(data);
        schema.content[0].ref.setBusy(false);
      }
    });
  };

  ReportAPIs.getClnSubscriptionReport({
    limit: PAGE_LIMIT,
    offset: 0,
  }).then(handleSuccess, () => handleSuccess([]));
};

const download = (schema, data, store) => {
  const table = schema.content[0].ref;
  const filteredData = table ? table.state.body : [];

  if (!filteredData.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "No data Available",
        content: "No data Available",
        createAt: Date.now(),
        autoClose: 8000,
        showError: true,
      },
    });
    return;
  }

  const heads = schema.content[0].head;
  const csvData = filteredData.map((row) => {
    const item = {};
    heads.forEach((head) => {
      item[head.name] = row[head.key];
    });
    return item;
  });

  JSONToCSVConvertor(csvData, "subscription_report", false);
};

const schema = {
  key: "subscription_report",
  name: "Subscription Report",
  showPage: false,
  count: 0,
  finalData: null,
  toolbar: [
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: download,
      tooltip: "Download Page",
      alignRight: true,
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        { key: "vehicleno", name: "Vehicle No" },
        { key: "deviceno", name: "Device No" },
        { key: "activationstart", name: "Activation Start" },
        { key: "activationend", name: "Activation End" },
        { key: "remainingtenure", name: "Remaining Tenure" },
        { key: "subscriptionstatus", name: "Subscription Status" },
        { key: "isactive", name: "Status" },
      ],
    },
  ],
};

export default schema;
